import { FormStore, GlobalStore } from "@roc/feature-app-core";
import { action, makeObservable } from "mobx";

const proofOfReceiptForm = {
  fields: {
    annualTaxAmount: {
      value: 0,
      error: null,
      rule: 'required',
      message: 'Tax amount is required.',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class PropertyTaxesFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super({ ...proofOfReceiptForm }, globalStore);
    makeObservable(this, {
      load: action,
    });
  }

  load(data: Record<string, any>) {
    this.loadForm(data);
  }
}